// DrawingSetsOverlay.js

import React, { useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';

import useStore from '../../../store';

import { FaCog, FaTabletAlt, FaRegClock, FaExpand, FaDownload, FaSave, FaTrashAlt } from 'react-icons/fa';
import { FaGavel } from 'react-icons/fa6';
import { TbSticker, TbPhoto, TbMail } from 'react-icons/tb';

import './DrawingSetsOverlay.css'; // Подключаем стили
import { SquareIcon, HorizontalIcon, VerticalIcon } from './OrientationIcons';
import AspectRatioSlider from './AspectRatioSlider'; 


import { handleOpenInBrowser, handlePetAvatar, handleCreateSticker, handleSaveAccessory, handleAuction, handlePermanentSave, askClearCache } from './menuHandlers';

import { deleteAllGameCaches } from '../../../utils/caching/indexedDBcache';



function DrawingSetsOverlay({ store }) {

  const { t } = useTranslation();

  useStore(state=>state.render);
  const showReference = useStore(state=>state.showReference);


  const { ref } = store;
  const { telegram,menu, drawing, info, work, premium } = ref;
  const { game, user, group } = info;

  const {

    gameId,
    moderMode,

  } = telegram;

  const {
    premiumFeatures
  } = premium;

  const {
    authorGameSets, 
    saveGameSets, 
    saveUserSets, 
  } = work.methods;

  const {
    isAppleDevice,

  } = info.methods;

  const {

    hostAction,

  } = work.methods;

  const {

    openMenu, closeMenu,
    showPopupMessage,
    showTemporaryHint,
    delayPremiumMenu,

  } = menu.methods;


    // Добавлено: функция для определения текущего соотношения сторон для слайдера
  // Она обеспечивает обратную совместимость со старыми настройками
  const getCurrentAspectRatio = () => {
    const settings = game.settings || {};
    // Конвертируем старые значения для отображения на слайдере
    switch (settings.orientation) {
      case 'custom':
        return settings.aspectRatio;
      case 'vertical':
        return 800 / 1200; // ~0.667
      case 'horizontal':
        return 1200 / 800; // 1.5
      case 'square':
      default:
        return 1;
    }
  };
  const [localRatio, setLocalRatio] = useState(getCurrentAspectRatio());

  let gameSettings = [];

  const handleGameSetCheckbox = (key) => {

    authorGameSets({ [key]: !game.settings[key] }, (result)=>{
      window.location.reload();
    });

  };

  const moderEdit = () => {
    saveUserSets({ 
      moderEditing: user.moderEditing === gameId ? null : gameId }, (result)=>{
      window.location.reload();
    })
  };

  const handleOrientationChange = (newOrientation) => {
    saveUserSets({ orientation: newOrientation });
    authorGameSets({ orientation: newOrientation }, (result)=>{
      window.location.reload();
    });
  };


  const OrientationSelector = () => (
    <div className="orientation-options">
      {[
        { value: 'square', Icon: SquareIcon },
        { value: 'horizontal', Icon: HorizontalIcon },
        { value: 'vertical', Icon: VerticalIcon },
      ].map(({ value, Icon }) => (
        <button
          key={value}
          className={`orientation-option ${(game.settings.orientation || 'square') === value ? 'active' : ''}`}
          onClick={() => handleOrientationChange(value)}
        >
          <Icon />
        </button>
      ))}
    </div>
  );


  // Добавлено: новый обработчик для слайдера
  const handleAspectRatioChange = (newRatio) => {
    setLocalRatio(newRatio);
  };

  const handleAspectRatioApply = (newRatio = localRatio) => {

    const totalStrokes = Object.values(ref.history?.userStrokes || {}).flat().length;

    if (totalStrokes > 100) {
      showPopupMessage( {
        title: t('aspect_ratio.title'),
        message: t('aspect_ratio.text'),
        buttons: [
          { id: 'cancel', type: 'cancel', text: t('aspect_ratio.button_cancel') },
          { id: 'apply', type: 'default', text: t('aspect_ratio.button_apply') },
        ],
        callback: (buttonId) => {
          if (buttonId === 'apply') {
            handleAspectRatioSave(newRatio);
          }
        },
      })
    } else {
    handleAspectRatioSave(newRatio);
    }


  };

  const handleAspectRatioSave = (newRatio = localRatio) => {
    saveUserSets({ aspectRatio: newRatio, orientation: 'custom' });
    authorGameSets({ 
      aspectRatio: newRatio, 
      orientation: 'custom' // Устанавливаем orientation в 'custom' для совместимости
    }, (result)=>{
      window.location.reload();
    });
  };



  const handleReference = ()=>{
    useStore.setState(state=>{
    if (!state.showReference) { closeMenu(); }
      return {showReference: !showReference}
    });
  }

  const handleSaveImage = async () => {

    const popupParams = {
      title: t('save.title'),
      message: t('save.text'),
      buttons: [
        // { id: 'cancel', type: 'cancel', text: t('save.button_cancel') },

        isAppleDevice() ? 
        { id: 'cancel', type: 'cancel', text: t('save.button_cancel') } :
        { id: 'device', type: 'default', text: t('save.button_device') },
        { id: 'pm', type: 'default', text: t('save.button_pm') },
      ],
    };

    popupParams.callback = (buttonId) => {
      if (buttonId === 'device') { handleSaveHere() }
      else if (buttonId === 'pm') {
        window.croco?.haptic?.();

        hostAction('savePng', null, (result)=>{
          window.croco?.haptic?.();

          if (result) {
            showPopupMessage({
              title: t('was_saved_pm.success_title'),
              message: t('was_saved_pm.success_message'),
            });
          } else {
            showPopupMessage({
              title: t('was_saved.error_title'),
              message: t('was_saved.error_message'),
            });
          }

        });
      }
    }
    showPopupMessage(popupParams)

  }

  const handleSaveHere = async () => {

    try {
      const renderResult = await ref.drawing.methods.prepareRender();
      
      if (renderResult.error) {
        console.error("Render error:", renderResult.error);
        showPopupMessage({
          title: t('was_saved.error_title'),
          message: t('was_saved.error_message') + JSON.stringify(renderResult.error),
        });
        return;
      }

      if (renderResult.empty) {
        showPopupMessage({
          title: t('was_saved.error_title'),
          message: t('was_saved.error_message') + 'empty',
        });
        return;
      }

      const { imagePng } = renderResult;
      let blob;

      // Check the type of imagePng and create the appropriate Blob
      if (imagePng instanceof Blob) {
        blob = imagePng;
      } else if (imagePng instanceof ArrayBuffer) {
        blob = new Blob([new Uint8Array(imagePng)], { type: 'image/png' });
      } else if (typeof imagePng === 'string' && imagePng.startsWith('data:image/png;base64,')) {
        const base64Data = imagePng.split(',')[1];
        const byteCharacters = atob(base64Data);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        blob = new Blob([byteArray], { type: 'image/png' });
      } else {
        // If it's none of the above, assume it's raw binary data
        blob = new Blob([imagePng], { type: 'image/png' });
      }
      
      // Create a download link and trigger the download
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.style.display = 'none';
      a.href = url;
      a.download = `croco_${game.word}.png`;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);

      showPopupMessage({
        title: t('was_saved.success_title'),
        message: t('was_saved.success_message') + a.download,
      });
    } catch (error) {
      console.error("Save PNG error:", error);
      showPopupMessage({
        title: t('was_saved.error_title'),
        message: t('was_saved.error_message') + JSON.stringify(error),
      });
    }
  };


  const handleSendGameInPm = () => {
    hostAction('sendInPm', null, (result)=>{

      if (result?.success) {
        window.croco?.haptic?.();
        showPopupMessage({
          title: t('game_sent_pm.success_title'),
          message: t('game_sent_pm.success_message'),
        });
      } else if (result?.error) {
        showPopupMessage({
          title: t('game_sent_pm.error_title'),
          message: t('game_sent_pm.error_message') + result.error,
        });
      } 

    })
  }

  return (
    <>
      <div className="overlay-background" onClick={() => closeMenu()}></div>
      <div className="drawing-menu add-scroll touch-active">

        <div className="drawing-menu-settings">
          <span className="settings-title">{t('drawing.title')}</span>

          {/* {OrientationSelector()} */}

          <AspectRatioSlider 
            currentRatio={localRatio}
            onRatioChange={handleAspectRatioChange}
            onRatioApply={handleAspectRatioApply}
          />

          {gameSettings.map((setting) => (
            <div key={setting.key} className="drawing-menu-item">
              <label className="settings-label" style = {{
                opacity: game.settings[setting.key] ? 1 : 0.3
              }}>
                <input
                  type="checkbox"
                  className='drawing-menu-item-checkbox'
                  checked={game.settings[setting.key]}
                  onChange={() => handleGameSetCheckbox(setting.key)}
                  style={{
                    height: '20px',
                  }}
                />
                <span>{setting.label}</span>
              </label>
            </div>
          ))}

          <div className="drawing-menu-item">
            <label className="settings-label" style = {{
              opacity: game.settings.plus18 ? 1 : 0.3
            }}>
              <input
                type="checkbox"
                className='drawing-menu-item-checkbox'
                checked={game.settings.plus18}
                onChange={() => { authorGameSets({ plus18: !game.settings.plus18 }) }}
                style={{ height: '20px', }}
              />
              <span>{ t('settings.plus18') }</span>
            </label>
          </div>
          
          
          <div className="word-menu-item">
            <label className="settings-label" style = {{
              opacity: showReference ? 1 : 0.5
            }}>
              <input
                type="checkbox"
                className='word-menu-item-checkbox'
                checked={showReference}
                onChange={handleReference}
                style={{ height: '20px', }}
              />
              <span>{window.t('reference.title')}</span>
            </label>
          </div>

          <div className="drawing-menu-item">
            <label className="settings-label" style = {{
              opacity: game.settings.transparentBg ? 1 : 0.3
            }}>
              <input
                type="checkbox"
                className='drawing-menu-item-checkbox'
                checked={game.settings.transparentBg}
                onChange={() => { authorGameSets({ transparentBg: !game.settings.transparentBg }, ()=>window.location.reload()) }}
                style={{ height: '20px', }}
              />
              <span>{ t('settings.transparent_bg') }</span>
            </label>
          </div>



          <div className="drawing-menu-item" onClick={()=>{handleOpenInBrowser({ t, hostAction, showPopupMessage, showTemporaryHint })}}>
            <label className="settings-label">
            <FaExpand className="settings-label-icon"/>
              <span>{t('fullscreen.button_start')}</span>
            </label>
          </div>


          <div className="drawing-menu-item" onClick={handleSendGameInPm}>
            <label className="settings-label">
              <TbMail className="settings-label-icon"/>
              <span>{t('settings.send_in_pm')}</span>
            </label>
          </div>

          <div 
              className="drawing-menu-item" 
              onClick={()=>{askClearCache({ showPopupMessage, deleteAllGameCaches, ref })}}
          >
            <label className="settings-label">
            <FaTrashAlt className="settings-label-icon"/>
              <span>{t('cache.button_clear_cache')}</span>
            </label>
          </div>

          {/* <div className="word-menu-item" onClick={()=>{handlePermanentSave({ t, hostAction, showPopupMessage, showTemporaryHint })}}>
            <label className="settings-label">
            <FaSave className="settings-label-icon"/>
              <span>{t('permanent.button_permanent')}</span>
            </label>
          </div> */}

          { game.accessory ? 
            (
              <div className="drawing-menu-item" onClick={()=>{handleSaveAccessory({ t, hostAction, showPopupMessage })}}>
                <label className="settings-label">
                <FaDownload className="settings-label-icon"/>
                  <span>{t('pet.accessory.button_save')}</span>
                </label>
              </div>
            ) : (
              <>
                <div className="drawing-menu-item" onClick={handleSaveImage}>
                  <label className="settings-label">
                  <FaDownload className="settings-label-icon"/>
                    <span>{t('save.button_save')}</span>
                  </label>
                </div>

                { !game.clone && (
                    <div className="drawing-menu-item" onClick={()=>{handlePetAvatar({ t, hostAction, showPopupMessage })}}>
                      <label className="settings-label">
                      <TbPhoto className="settings-label-icon"/>
                        <span>{t('pet.avatar.button_set')}</span>
                      </label>
                    </div>
                )}

                <div className="drawing-menu-item" onClick={()=>{handleCreateSticker({ t, hostAction, showPopupMessage })}}>
                <label className="settings-label">
                <TbSticker className="settings-label-icon"/>
                  <span>{t('sticker.button_create')}</span>
                </label>
                </div>
              </>
              )
            }

            <div 
              className="drawing-menu-item" 
              onClick={()=>{handleAuction({ t, hostAction, showPopupMessage, game })}}
            >
              <label className="settings-label">
              <FaGavel className="settings-label-icon"/>
                <span>{t('auction.button_apply')}</span>
              </label>
            </div>


     

        </div>

        {
          user.moder && (
            <button className="wide-button" onClick={moderEdit}>
              {t('settings.moderate')}
            </button>
          )
        }

        <button className="wide-button" onClick={() => {
          closeMenu();
          delayPremiumMenu('menu');
        }}>
          {t('settings.premium')}
        </button>

        <button className="gray-button" onClick={()=>{ openMenu('settings', true); }}>
          <FaCog style={{ marginRight: '8px', marginBottom: '3px', verticalAlign: 'middle'}} />
          {t('settings.title')}
        </button>

        <button className="gray-button" onClick={() => closeMenu()}>
          {t('settings.back')}
        </button>


      </div>


    </>
  );
}

export default DrawingSetsOverlay;
